import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  CHANGE_USER_WORK_STATUS,
  CREATE_USER,
  DISABLE_2FA,
  EDIT_BALANCE,
  EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  ENABLE_2FA,
  GET_2FA_DATA,
  LOAD_USERS_LIST,
  RESET_SUPPORT_LIMIT,
} from './user';
import { LOAD_DEPOSITS_LIST } from '@/store/const/deposits';
import {
  ADD_WITHDRAW,
  BUMP_WITHDRAW,
  CANCEL_WITHDRAW,
  CONFIRM_WITHDRAW,
  LOAD_WITHDRAWS_LIST,
  RESTART_WITHDRAW,
} from '@/store/const/withdraws';
import {
  CREATE_WALLET,
  DELETE_WALLET,
  EDIT_WALLET_DESCRIPTION,
  LOAD_BALANCES,
  LOAD_AML_REPORTS,
  LOAD_WALLETS_LIST,
  REFRESH_WALLET,
  CHECK_WALLET_AML,
} from '@/store/const/wallets';
import {
  ADD_WHITELIST_WALLET,
  DELETE_WHITELIST_WALLET,
  EDIT_ACCUMULATION_SETTINGS,
  LOAD_ACCUMULATION_SETTINGS,
  LOAD_AML_BALANCE,
  LOAD_SETTINGS,
} from '@/store/const/settings';

const path = {
  [AUTH_LOGIN]: 'users/login',
  [AUTH_LOGOUT]: 'users/logout',
  [LOAD_USERS_LIST]: 'users',
  [CREATE_USER]: 'users',
  [EDIT_USER]: 'users/:name:',
  [EDIT_BALANCE]: 'users/:id:/balance',
  [EDIT_SUPPORT_LIMIT]: 'users/:id:/limit/edit',
  [RESET_SUPPORT_LIMIT]: 'users/:id:/limit/reset',
  [CHANGE_USER_WORK_STATUS]: 'users/settings/work_status/:status:',
  [GET_2FA_DATA]: 'users/2fa/data',
  [ENABLE_2FA]: 'users/2fa/enable',
  [DISABLE_2FA]: 'users/2fa/disable',
  [LOAD_DEPOSITS_LIST]: 'deposits',
  [LOAD_WITHDRAWS_LIST]: 'withdraws',
  [ADD_WITHDRAW]: 'withdraws',
  [CONFIRM_WITHDRAW]: 'withdraws/confirm/:id:',
  [RESTART_WITHDRAW]: 'withdraws/restart/:id:',
  [BUMP_WITHDRAW]: 'withdraws/bump/:id:',
  [CANCEL_WITHDRAW]: 'withdraws/cancel/:id:',
  [LOAD_WALLETS_LIST]: 'wallets',
  [CREATE_WALLET]: 'wallets',
  [DELETE_WALLET]: 'wallets/:id:',
  [LOAD_BALANCES]: 'wallets/balance',
  [LOAD_AML_REPORTS]: 'wallets/accumulation/aml/reports',
  [REFRESH_WALLET]: 'wallets/:id:/refresh',
  [CHECK_WALLET_AML]: 'wallets/:id:/aml-check',
  [LOAD_SETTINGS]: 'settings/global',
  [LOAD_ACCUMULATION_SETTINGS]: 'settings/accumulation',
  [EDIT_ACCUMULATION_SETTINGS]: 'settings/accumulation',
  [ADD_WHITELIST_WALLET]: 'settings/whitelist',
  [DELETE_WHITELIST_WALLET]: 'settings/whitelist',
  [LOAD_AML_BALANCE]: 'wallets/accumulation/aml/balance',
  [EDIT_WALLET_DESCRIPTION]: 'wallets/:wallet_id:/description',
};
export default path;
